var initialPosition = 0;

//Funcion extendida animatecss
$.fn.extend({
	animateCss: function(animationName, callback) {
		var animationEnd = (function(el) {
			var animations = {
				animation: 'animationend',
				OAnimation: 'oAnimationEnd',
				MozAnimation: 'mozAnimationEnd',
				WebkitAnimation: 'webkitAnimationEnd',
			};

			for (var t in animations) {
				if (el.style[t] !== undefined) {
					return animations[t];
				}
			}
		})(document.createElement('div'));

		$(this).addClass('animated ' + animationName).one(animationEnd, function() {
			if(typeof callback === 'function'){
				callback();
			}
		});

		return this;
	}
});

$(document).ready(function () {

	//Aplicar delay a elementos
	$('.animar[data-delay]').each(function() {
		var the_delay = $(this).attr('data-delay');
		$(this).css({
			'-webkit-animation-delay': the_delay + 'ms',
			'-o-animation-delay': the_delay + 'ms',
			'animation-delay': the_delay + 'ms'
		});
	});

	//Slider media
	$('.slb-slider-media').each(function(){

		var slideMedia = $(this);
		var totalItems = slideMedia.find('div');
		var sliderControls = slideMedia.siblings('.slb-slider-media-controls');
		var loopState = false;

		if(totalItems.length > 1){
			loopState = true;
		}

		slideMedia.slick({
			infinite: false,
			centerMode: false,
			adaptiveHeight: true, 
			arrows: false,
			dots: true,
			variableWidth: true,
			swipeToSlide: true,
			touchMove: true
		});

		//sliderControls.find('.slb-prev').click(function(e){
		//	e.preventDefault();
		//	slideMedia.slick('slickPrev');
		//});

		//sliderControls.find('.slb-next').click(function(e){
		//	e.preventDefault();
		//	slideMedia.slick('slickNext');
		//});

		//slideMedia.on('afterChange', function (event, slick) {
		//	sliderControls.find('.slb-current').html(slick.currentSlide + 1);
		//});

	});

	//Ir hacia abajo

	$('#down-section').click(function(e){
		e.preventDefault();
		var parentSection = $(this).parents('.layout');
		var parentSectionOffset = parentSection.offset().top;
		var parentSectionHeight = parentSection.height();
		$('html,body').animate({scrollTop: parentSectionOffset + parentSectionHeight}, 500, 'swing');
	});


	//Ejecutar acciones de scroll
	scrollAction();
  
	//Mostrar home
	$('body').addClass('slb-loaded');

	//Limitar cantidad a agregar en input

	$('.quantity__input').on('input change', function () {
		let max = parseInt($(this).attr('data-limit-max'));
		let current = parseInt($(this).val());

		if (current > max) {
			$(this).val(max);
		}

		if (current < 1 || isNaN(current)) {
			$(this).val(1); // valor mínimo permitido
		}
	});

	//Mostrar total de precio producto

	var quantityInput = $('#product-info .quantity__input');
	var priceElement = $('#hidden-product-price');
	var totalElement = $('#slb-custom-total-price');

	if (quantityInput.length || priceElement.length || totalElement.length){
		
		function getActivePrice() {
			//Si existe precio en rebaja, úsalo; de lo contrario usa el regular
			var salePrice = parseFloat(priceElement.data('price'));
			var regularPrice = parseFloat(priceElement.data('compare-at-price'));

			if (regularPrice && salePrice < regularPrice) {
				return salePrice; //precio rebajado
			} else {
				return regularPrice || salePrice; //precio normal
			}
		}

		function updateTotal() {
			var qty = parseInt(quantityInput.val()) || 1;
			var unitPrice = getActivePrice();
			var total = unitPrice * qty;

			var formatted = new Intl.NumberFormat('es-MX', {
			style: 'currency',
			currency: 'MXN'
			}).format(total);
			
			totalElement.text(formatted + " p/p");
		}

		//Recalcular al cambiar cantidad
		quantityInput.change(updateTotal);
		updateTotal();

	}

	//Mostrar asientos para nombres segun cantidad

	$('.cart-names-inputs').each(function(){

		var inputs_container = $(this);
		var line = inputs_container.attr('data-line');
		var inputs = inputs_container.find('.name-input');
  		var quantity = inputs.length;

		inputs_container.on('change', '.name-input', function () {

			var properties = {};
			var turno_asiento = 1;

			inputs.each(function () {	

				var value = $(this).val().trim();

				if(value == ''){
					value = 'sin nombre';
				}

				properties['Asiento ' + turno_asiento] = value;

				turno_asiento++;

			});

			fetch('/cart/change.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ line: line, quantity: quantity, properties: properties })
			})
			.then(res => res.json())
			.then(cart => console.log('Propiedades actualizadas'))
			.catch(err => console.error('Error actualizando propiedades:'));
		});

	});

	// 2️⃣ Validar antes de hacer checkout
	$('.cart form').on('submit', function (e) {
		var hasEmpty = false;
		var inputFocus;

		// Solo revisar inputs dentro de este formulario
		$(this).find('.name-input').each(function () {
			if ($(this).val().trim() === '') {
				hasEmpty = true;
				inputFocus = $(this);
				return false;
			}
		});

		if (hasEmpty) {
			e.preventDefault(); // cancela el envío
			alert('Por favor, ingresa todos los nombres de los asistentes antes de continuar con el pago.');
			inputFocus.focus();
			return false; // adicional para mayor compatibilidad
		}
	});
  
});

$(window).scroll(function () {
	scrollAction();
});

document.addEventListener('touchend', function(){
	if(navigator.userAgent.match(/(iPod|iPhone|iPad)/)){
		scrollAction();
	}
});

function scrollAction(the_position) {

	if (typeof $.fn.animateCss !== 'function') {
		$.fn.extend({
			animateCss: function(animationName, callback) {
				var animationEnd = (function(el) {
					var animations = {
						animation: 'animationend',
						OAnimation: 'oAnimationEnd',
						MozAnimation: 'mozAnimationEnd',
						WebkitAnimation: 'webkitAnimationEnd',
					};

					for (var t in animations) {
						if (el.style[t] !== undefined) {
							return animations[t];
						}
					}
				})(document.createElement('div'));

				$(this).addClass('animated ' + animationName).one(animationEnd, function() {
					if(typeof callback === 'function'){
						callback();
					}
				});

				return this;
			}
		});
	}

	var position = $(window).scrollTop();
	if(the_position){
		position = the_position;
	}
	var windowVp = $(window).height();
	var windowWp = $(window).width();

	var focus_window = position + ( $(window).height() / 2 );
	var hidde_window = position + $(window).height();

	//Animar bloques al llegar a su posicion
	$('.layout').each(function(index, el) {
		var the_layout = $(this);
		var the_items = the_layout.find('.animar');
		var altoSeccion = the_layout.innerHeight();
		var inicioSeccion = the_layout.offset().top;
		var finSeccion = inicioSeccion + altoSeccion;
		if(windowWp >= 768){
			var margin_scroll = 200;
		}else{
			var margin_scroll = 100;
		}

		//Ejecutar solamente si hay elementos a animar
		if(the_layout.find('.animar').length || the_layout.find('.animado').length){
		
			//Detectar sentido scroll
			if(position > initialPosition){
				//Scroll hacia abajo por lo que se muestran las animaciones al estar visibles en la pantalla
				var position_view = position + (windowVp / 1) - 20;
			}else{
				//Scroll hacia arriba por lo que se ocultaran las animaciones hasta que no sean visibles
				var position_view = position + (windowVp / 1);
			}

			var elements = the_layout.find('[data-lazy="true"]');
			if(elements.length){
				if(navigator.userAgent.match(/(iPod|iPhone|iPad)/)){
					lazy_items.loadAll(); //Cargar todas las imagenes
				}
			}

			//Si el navegador es corrido en ios
			if(navigator.userAgent.match(/(iPod|iPhone|iPad)/)){
				//Animar elementos
				the_items.each(function() {
					var the_item = $(this);
					var the_animation = the_item.attr('data-animation');
					the_item.animateCss(the_animation, function(element){
						the_item.removeClass('animated ' + the_animation).removeClass('animar').addClass('animado');
					});
				});
			}else{
				//Verificar posicion
				if(position_view >= inicioSeccion && position <= finSeccion){
					//Si el navegador es safari
					if((navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1)){
						//Animar elementos
						the_items.each(function() {
							var the_item = $(this);
							var the_animation = the_item.attr('data-animation');
							the_item.animateCss(the_animation, function(element){
								the_item.removeClass('animated ' + the_animation).removeClass('animar').addClass('animado');
							});
						});
					}else{
						the_items.each(function(index, el) {
							var the_item = $(this);
							var altoElemento = the_item.innerHeight();
							var inicioElemento = the_item.offset().top;
							var finElemento = inicioElemento + altoElemento;
							var the_animation = the_item.attr('data-animation');

							if(the_item.css('position') === 'absolute' || the_item.css('position') === 'fixed'){
								if(the_item.hasClass('animar')){
									the_item.animateCss(the_animation, function(element){
										the_item.removeClass('animated ' + the_animation).removeClass('animar').addClass('animado');
									});
								}
							}else{
								//Animar contenido si la posicion es cercana al inicio de la seccion
								if(position_view >= inicioElemento && position < finElemento){
									//Animar contenido
									if(the_item.hasClass('animar')){
										the_item.animateCss(the_animation, function(element){
											the_item.removeClass('animated ' + the_animation).removeClass('animar').addClass('animado');
										});
									}
								}
							}
						});
					}
				}else{
					//Si el navegador es corrido en ios o es safari
					if(navigator.userAgent.match(/(iPod|iPhone|iPad)/) || (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1)){
						//Evitamos que desaparezcan
					}else{
						the_layout.find('.animado').removeClass('animado').addClass('animar');
					}
				}
			}

		}
	});

	//Animar parallax
	$('.parallax-contenedor').each(function(){

		var parent_parallax = $(this);
		var parallax_position = parent_parallax.offset().top;
		var item_parallax = parent_parallax.find('.parallax-capa');
		var parallax_move = Math.ceil( ( focus_window - parallax_position ) / 10 ) * -.5;

		if(parallax_move > -100 && parallax_move < 0){

			item_parallax.css({
				'margin-top': parallax_move + 'px'
			});

		}

	});

	//Animar elementos scroll
	if($('.scroll-move').length){

		$('.scroll-move').each(function() {

			var element = $(this);
			var position_y = element.offset().top;
			var move_y = parseInt( (focus_window - position_y) / 4 ) - 120;
			var rotate = 0;
			var limit_top = -200;

			if($(window).width() < 768){

				limit_top = -200;

			}

			if(move_y >= limit_top && move_y < 200){

				rotate = (move_y / 2);

				if(element.hasClass('short')){
					move_y = move_y / 2;
					rotate = (move_y / 4);
				}

				if(element.hasClass('reverse')){
					move_y = move_y * -1;
				}

				if(element.hasClass('rotate')){
					move_y = 0;
				}

				if(element.hasClass('move')){
					rotate = 0;
				}

				element.children().first().css({
					'transform': 'translateY(' + (move_y * -1) + 'px) rotate(' + rotate + 'deg)'
				});

			}

		});

	}

	//Guardar valor al parar scroll
	clearTimeout(scroll_stop);
	var scroll_stop = setTimeout(function() {
		initialPosition = position;
	}, 100);

}